export default __webpack_public_path__ + "static/pultrudedfrp3-a80e038ddd30e3ca979d2018457706f0.jpg";